import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_QUICKBOOKS_CONNECTION_STATUS } from '../graphql/quickbooks';
import QuickBooksCustomerAssignments from '../components/settings/QuickBooksCustomerAssignments';

export default function QuickBooksAssignments() {
  const navigate = useNavigate();

  const { data, loading, error } = useQuery(GET_QUICKBOOKS_CONNECTION_STATUS, {
    fetchPolicy: 'network-only',
  });

  const isConnected = data?.quickBooksConnectionStatus?.isConnected || false;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate('/dashboard/reports/work-orders')}
            className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
            aria-label="Back to Reports"
            tabIndex={0}
          >
            <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
            </svg>
            Work Order Reports
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="mb-2">
          <h1 className="text-2xl font-semibold text-gray-900">QuickBooks Property Assignments</h1>
          <p className="text-gray-600 mt-1">Assign QuickBooks customers to properties for invoicing</p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <svg className="animate-spin h-5 w-5 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-sm text-gray-500">Checking QuickBooks connection...</span>
          </div>
        ) : error ? (
          <div className="rounded-md bg-red-50 p-4 border border-red-200">
            <p className="text-sm text-red-800">Error checking QuickBooks connection: {error.message}</p>
          </div>
        ) : !isConnected ? (
          <div className="rounded-md bg-yellow-50 p-4 border border-yellow-200 mt-4">
            <div className="flex">
              <svg className="h-5 w-5 text-yellow-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">QuickBooks Not Connected</h3>
                <p className="mt-1 text-sm text-yellow-700">
                  QuickBooks must be connected before you can assign customers to properties. Please contact an administrator to connect QuickBooks in Settings.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <QuickBooksCustomerAssignments />
        )}
      </div>
    </div>
  );
}
